import { render, staticRenderFns } from "./TextGroup.vue?vue&type=template&id=7a4cc39e&"
import script from "./TextGroup.vue?vue&type=script&lang=js&"
export * from "./TextGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4cc39e')) {
      api.createRecord('7a4cc39e', component.options)
    } else {
      api.reload('7a4cc39e', component.options)
    }
    module.hot.accept("./TextGroup.vue?vue&type=template&id=7a4cc39e&", function () {
      api.rerender('7a4cc39e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/TextGroup.vue"
export default component.exports